export default "__VITE_ASSET__D9XJXv6t__"